import useDistance from './useDistance';
import useDuration from './useDuration';

export default function useDistanceAndDuration() {
  const { formatDistance } = useDistance();
  const { formatDuration } = useDuration();

  function format(distance, time, double, hideDouble) {
    const data = {};

    if (double) {
      distance /= 2;
      time /= 2;
    }

    if (distance) {
      data.distance = `${formatDistance(distance)} ${double && !hideDouble ? '× 2' : ''}`;
    }

    if (time) {
      data.time = formatDuration(time, double && !hideDouble);
    }

    return data;
  }

  return {
    format,
  };
}
